import { Stack, Row, Col, Container } from "react-bootstrap";
import { useOutletContext } from "react-router-dom"; 

import LoanCard from "./loan_card";
import TotalDuesCard from "./total_dues_card";
import UpcomingInstallments from "./upcoming_installments";
import RepaymentDetails from "./repayment_details";


export function LoanInformation() {
  const { loanUUID, loanSummary } = useOutletContext();

  return (
    <Container fluid>
      <h1 className="text-2xl fw-bolder my-4">Loan Information</h1>

      <Row className="g-3">
        <Col xs={12} md={9}>
          <Stack gap={3}>
            <LoanCard loanSummary={loanSummary} />
            <RepaymentDetails loanSummary={loanSummary} loanUUID={loanUUID} />
          </Stack>
        </Col>

        <Col xs={12} md={3}>
          <Stack gap={3}>
            <TotalDuesCard loanSummary={loanSummary} />
            <UpcomingInstallments loanUUID={loanUUID} />
          </Stack>
        </Col>
      </Row>
    </Container>
  );
}
